MetierDesc = {
	init: ->
		console.log "MetierDesc init"

}